<template>
    <form action="/admin/settings" method="post" @submit.prevent="onSubmit">
        <label for="default_credit_package">Pacote de créditos iniciais</label>
        <div class="row">
            <div class="form-group col-md-9">
                <select name="default_credit_package"
                        id="default_credit_package"
                        class="form-control"
                        v-model="form.default_credit_package"
                >
                    <option :value="null">Selecione</option>
                    <option v-for="creditPackage in creditPackages"
                            :key="creditPackage.id"
                            :value="creditPackage.id"
                    >
                        {{ creditPackage.amount }} créditos
                        (R$ {{ creditPackage.price }})
                    </option>
                </select>
            </div>
        </div>
        <p>
            Selecione o pacote de créditos que irá ser creditado a
            todo novo usuário da plataforma no ato de seu registro
        </p>
        <label for="default_credit_package">Pacote Por Indicação</label>
        <div class="row">
            <div class="form-group col-md-9">
                <select name="default_credit_package_share_code"
                        id="default_credit_package_share_code"
                        class="form-control"
                        v-model="form.default_credit_package_share_code"
                >
                    <option :value="null">Selecione</option>
                    <option v-for="creditPackage in creditPackages"
                            :key="creditPackage.id"
                            :value="creditPackage.id"
                    >
                        {{ creditPackage.amount }} créditos
                        (R$ {{ creditPackage.price }})
                    </option>
                </select>
            </div>
        </div>
        <p>
            Selecione o pacote de créditos que irá ser creditado para
            quem indicar outro Perito Assitente
        </p>
        <label for="default_bid_cost">Custo por demanda em créditos</label>
        <div class="row">
            <div class="form-group col-md-9">
                <input type="text"
                        class="form-control"
                        name="default_bid_cost"
                        v-model="form.default_bid_cost"
                        id="default_bid_cost"
                >
            </div>
        </div>
        <p>
            Defina quanto os peritos deverão investir de seus crédito por cada inscrição
        </p>

        <label for="default_tarifa_boleto">Tarifa por boleto (Pacote Créditos)</label>
        <div class="row">
            <div class="form-group col-md-9">
                <input type="number"
                        class="form-control"
                        name="default_tarifa_boleto"
                        v-model="form.default_tarifa_boleto"
                        id="default_tarifa_boleto"
                        min="0"
                        step="0.01"
                >
            </div>
        </div>
        <p>
            Configurar o valor da tarifa para pagamento por boleto. Ex: 1.99
        </p>

        <label for="default_tarifa_pix">Tarifa por pix (Pacote Créditos)</label>
        <div class="row">
            <div class="form-group col-md-9">
                <input type="number"
                        class="form-control"
                        name="default_tarifa_pix"
                        v-model="form.default_tarifa_pix"
                        id="default_tarifa_pix"
                        min="0"
                        step="0.01"
                >
            </div>
        </div>
        <p>
            Configurar o valor da tarifa para pagamento por pix. Ex: 1.99
        </p>

        <label for="default_taxa_juros_parcelado">Taxa de Juros no Parcelado (%)</label>
        <div class="row">
            <div class="form-group col-md-9">
                <input type="number"
                        class="form-control"
                        name="default_taxa_juros_parcelado"
                        v-model="form.default_taxa_juros_parcelado"
                        id="default_taxa_juros_parcelado"
                        min="0"
                        step="0.01"
                >
            </div>
        </div>
        <p>
            Para configurar o 10% de taxa de juros, colocar o valor 10.00
        </p>

        <label for="default_max_num_parcela">Número máximo de parcelas</label>
        <div class="row">
            <div class="form-group col-md-9">
                <input type="number"
                        class="form-control"
                        name="default_max_num_parcela"
                        v-model="form.default_max_num_parcela"
                        id="default_max_num_parcela"
                        min="0"
                        step="0.01"
                >
            </div>
        </div>
        <p>
        Configurar o número máximo de parcelas para compras de créditos e intermediação
        </p>

        <label for="default_fee_cost">Taxa de intermediação ( % / 100 )</label>
        <div class="row">
            <div class="form-group col-md-9">
                <input type="number"
                        class="form-control"
                        name="default_percent_fee_intermediation"
                        v-model="form.default_percent_fee_intermediation"
                        id="default_percent_fee_intermediation"
                        min="0"
                        step="0.01"
                >
            </div>
        </div>
        <p>
            Para configurar taxa de 10%, colocar no campo o valor 0.10
        </p>

        <label for="default_fee_cost">Prazo para aguardar avaliação</label>
        <div class="row">
            <div class="form-group col-md-9">
                <input type="number"
                        class="form-control"
                        name="default_dias_esperando_avaliacao_contratante"
                        v-model="form.default_dias_esperando_avaliacao_contratante"
                        id="default_dias_esperando_avaliacao_contratante"
                        min="0"
                        step="0.01"
                >
            </div>
        </div>
        <p>
            Configurar o prazo que a plataforma aguarda para finalizar a intermediação
        </p>

        <div class="form-group">
            <button type="submit" class="btn btn-md btn-primary" >Salvar alterações</button>
        </div>
    </form>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    mounted() {
        this.loadCreditPackages();

        this.loadSettings();
    },
    data() {
        return {
            creditPackages: [],
            form: new Form({
            }),
        };
    },
    methods: {
        loadSettings() {
            axios.get('/admin/settings')
                .then(({data}) => {
                    this.form = new Form(data);
                }).catch(() => {
                    toastr.error('Erro ao carregar configurações!');
                });
        },
        loadCreditPackages() {
            axios.get('/credit-packages')
                .then(({data}) => {
                    this.creditPackages = data;
                }).catch(() => {
                    toastr.error('Erro ao carregar pacotes de créditos!');
                });
        },
        onSubmit() {
            this.form.patch('/admin/settings')
                .then((data) => {
                    this.form = new Form(data);
                    toastr.success('Configurações atualizadas com sucesso!');
                }).catch(() => {
                    toastr.error('Erro ao atualizar configurações!');
                })
        }
    }
}
</script>
